// src/components/badge/recipe.ts
import { tv } from "tailwind-variants";
var badgeRecipe = tv({
  base: ["inline-flex", "items-center", "rounded-md"],
  variants: {
    variant: {
      subtle: ["bg-interactive-surface", "text-foreground-subtle"],
      plain: ["text-foreground"]
    },
    colorPalette: {
      critical: [""],
      warning: [""],
      success: [""],
      info: [""],
      emphasis: [""],
      red: [""],
      orange: [""],
      green: [""],
      blue: [""],
      purple: [""]
    },
    size: {
      xs: [
        "min-h-5",
        "gap-1",
        "px-1",
        "my-label-xs",
        "[&>svg]:w-3",
        "[&>svg]:h-3"
      ],
      sm: [
        "min-h-6",
        "gap-1",
        "px-2",
        "my-label-xs",
        "[&>svg]:w-4",
        "[&>svg]:h-4"
      ],
      md: [
        "min-h-7",
        "gap-1",
        "px-2",
        "my-label-xs",
        "[&>svg]:w-4",
        "[&>svg]:h-4"
      ],
      lg: [
        "min-h-8",
        "gap-1.5",
        "px-3",
        "my-label-sm",
        "[&>svg]:w-5",
        "[&>svg]:h-5"
      ],
      xl: [
        "min-h-9",
        "gap-1.5",
        "px-3",
        "my-label-sm",
        "[&>svg]:w-5",
        "[&>svg]:h-5"
      ]
    }
  },
  compoundVariants: [
    {
      colorPalette: ["critical", "red"],
      variant: "subtle",
      class: [
        "bg-semantic-critical-surface-subtle",
        "text-semantic-critical-foreground-subtle"
      ]
    },
    {
      colorPalette: ["warning", "orange"],
      variant: "subtle",
      class: [
        "bg-semantic-warning-surface-subtle",
        "text-semantic-warning-foreground-subtle"
      ]
    },
    {
      colorPalette: ["success", "green"],
      variant: "subtle",
      class: [
        "bg-semantic-success-surface-subtle",
        "text-semantic-success-foreground-bold"
      ]
    },
    {
      colorPalette: ["info", "blue"],
      variant: "subtle",
      class: [
        "bg-semantic-info-surface-subtle",
        "text-semantic-info-foreground-subtle"
      ]
    },
    {
      colorPalette: ["emphasis", "purple"],
      variant: "subtle",
      class: [
        "bg-semantic-emphasis-surface-subtle",
        "text-semantic-emphasis-foreground-subtle"
      ]
    },
    {
      colorPalette: ["critical", "red"],
      variant: "plain",
      class: "text-semantic-critical-foreground-subtle"
    },
    {
      colorPalette: ["warning", "orange"],
      variant: "plain",
      class: "text-semantic-warning-foreground-subtle"
    },
    {
      colorPalette: ["success", "green"],
      variant: "plain",
      class: "text-semantic-success-foreground-subtle"
    },
    {
      colorPalette: ["info", "blue"],
      variant: "plain",
      class: "text-semantic-info-foreground-subtle"
    },
    {
      colorPalette: ["emphasis", "purple"],
      variant: "plain",
      class: "text-semantic-emphasis-foreground-subtle"
    }
  ],
  defaultVariants: {
    variant: "subtle",
    size: "md"
  }
});

export {
  badgeRecipe
};
